var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ScuritVrifie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24.048828 2 A 1.50015 1.50015 0 0 0 22.998047 2.3847656 C 22.998047 2.3847656 15.490168 9 6.5 9 A 1.50015 1.50015 0 0 0 5 10.5 L 5 22.759766 C 5 29.437814 8.0894135 40.426402 23.417969 46.882812 A 1.50015 1.50015 0 0 0 24.582031 46.882812 C 39.910586 40.426403 43 29.437814 43 22.759766 L 43 10.5 A 1.50015 1.50015 0 0 0 41.5 9 C 32.509832 9 25.001953 2.3847656 25.001953 2.3847656 A 1.50015 1.50015 0 0 0 24.048828 2 z M 24 5.4277344 C 26.062966 7.0863651 32.111257 11.337189 40 11.875 L 40 22.759766 C 40 28.502023 37.793444 37.765684 24 43.826172 C 10.206556 37.765684 8 28.502023 8 22.759766 L 8 11.875 C 15.888743 11.337189 21.937034 7.0863651 24 5.4277344 z M 31.470703 17.986328 A 1.50015 1.50015 0 0 0 30.439453 18.439453 L 21.5 27.378906 L 17.560547 23.439453 A 1.50015 1.50015 0 1 0 15.439453 25.560547 L 20.439453 30.560547 A 1.50015 1.50015 0 0 0 22.560547 30.560547 L 32.560547 20.560547 A 1.50015 1.50015 0 0 0 31.470703 17.986328 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ScuritVrifie);
export default __webpack_public_path__ + "static/media/icons8-sécurité-vérifiée.b558f53965bb1460626c18447de8379e.svg";
export { ForwardRef as ReactComponent };